/**
 * Trạng thái yêu cầu từ cấp dưới
 */
export default {
    /**
     * Không
     */
    None: 0,
    /**
     * Cấp dưới yêu cầu thu hồi
     */
    RequestRevoke: 5,
    /**
     * Cấp trên đồng ý thu hồi
     */
    AcceptRevoke: 10,
    /**
     * Cấp trên từ chối thu hồi
     */
    RejectRevoke: 15
}